import React from "react";
import {FormattedMessage, useIntl} from "react-intl";

import {createTheme} from "@mui/material/styles";

import Content from "views/quote/components/show/notes/components/NoteBlock/Content";
import CustomerAddCommentMessage from "views/quote/components/show/notes/components/Messages/CustomerAddCommentMessage";
import Header from "views/quote/components/show/notes/components/NoteBlock/Header";
import NoteBlock from "views/quote/components/show/notes/components/NoteBlock";
import NoteCardContent from "views/quote/components/show/notes/components/NoteBlock/NoteCardContent";

import {ORDER_CUSTOMER_COMMENT} from "views/quote/enums/quoteNoteType";
import {infoColor} from "assets/jss/main";

const customerCommentTheme = createTheme({
    palette: {primary: {main: infoColor}},
});

function CustomerComment({item, order}) {
    const intl = useIntl();

    const user = item.member?.user;
    const customerName = order?.customerBillingFirstname && order?.customerBillingLastname
        ? `${order.customerBillingFirstname} ${order.customerBillingLastname}`
        : (user ? `${user.givenName} ${user.familyName}` : '');

    return (
        <NoteBlock theme={customerCommentTheme}>
            <NoteCardContent>
                <Header
                    title={intl.formatMessage({id: 'picking.order.show.note.customerComment.title'})}
                    subtitle={order?.customerBillingEmail}
                    date={item.createdAt}
                    centerContent={<CustomerAddCommentMessage customerName={customerName} />}
                    noteType={ORDER_CUSTOMER_COMMENT}
                />
                <div style={{borderTop: '1px solid #e0e0e0'}}>
                    <Content content={item.content} />
                </div>
            </NoteCardContent>
        </NoteBlock>
    );
}

export default CustomerComment;
